module.exports = __webpack_public_path__ + "acceptancemark-paymentmethod-4-amazonpay.6dd5c423.svg";